export default __webpack_public_path__ + "static/media/icon-3dots-vertical-gray.d14eb9db.svg";